<ng-container *ngIf="show">
    <div class="ghost-content" [ngStyle]="{ opacity: opacity / 100 }">
        <ng-content></ng-content>
    </div>
</ng-container>
